module.exports = __webpack_public_path__ + "img/6-2.bc84e748.png";